import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalstorageService {

  constructor() { }

  clearData() {
    localStorage.clear();
  }

  setData(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  removeData(key: string) {
    localStorage.removeItem(key);
  }

  getData(key: string) {
    return localStorage.getItem(key) || '[]';
  }

}
